import React from 'react'
import { translate } from 'react-i18next'
import './index.sass'

const FormInput = ({ onHandleChange, name, type, withError, label, textarea, error, t }) => (
  <div className={withError && error ? 'form-elem form-elem-error' : 'form-elem'}>
    <p className="caption">{label}</p>
    {textarea ? (
      <textarea
        type={type}
        id={name}
        onChange={onHandleChange}
        className="body-light ym-record-keys"
      />
    ) : (
      <input
        type={type}
        id={name}
        onChange={onHandleChange}
        className="body-light ym-record-keys"
      />
    )}
    {withError && error && <p className="error caption">{t('form.error')}</p>}
  </div>
)

export default translate('translations')(FormInput)
